<template>
  <div v-loading="loading" class="jb-report-preview">
    <jb-report-normal
      v-if="viewMode === 'normal' && orderData"
      :order-data="orderData"
    />
    <jb-report-secondhand
      v-else-if="viewMode === 'secondhand' && orderData"
      :order-data="orderData"
    />
    <div v-else-if="legacyImageUrl" class="jb-report-preview-legacy">
      <img :src="legacyImageUrl" alt="鉴别报告" class="jb-report-preview-legacy-img" />
    </div>
    <div v-else-if="!loading" class="jb-report-preview-empty">
      暂无报告数据
    </div>
  </div>
</template>

<script>
import { api } from "@/util/requestUrl";
import JbReportNormal from "./JbReportNormal.vue";
import JbReportSecondhand from "./JbReportSecondhand.vue";
import { isSecondhandJobOrderType } from "@/util/inspectionReportQr";
import { absReportAssetUrl } from "@/util/reportAssetUrl.js";

const ASSET_ORIGIN = "https://hzshixiang.site";

function useNewXwOrderReportTemplate(orderData) {
  if (!orderData) return false;
  const v = orderData.reportIssuedAt;
  return v != null && v !== "";
}

function isReportImageUrl(authenticate) {
  if (authenticate == null || authenticate === "") return false;
  const s = String(authenticate).trim();
  return (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("/")
  );
}

function absAssetUrl(u) {
  return absReportAssetUrl(u, ASSET_ORIGIN);
}

function normalizeOrderAssets(data) {
  if (!data || typeof data !== "object") return data;
  const next = { ...data };
  ["typeImage", "typeImages", "atlas2", "jbtp", "authenticate", "atlas1"].forEach((k) => {
    if (next[k]) next[k] = absAssetUrl(next[k]);
  });
  if (next.images != null && typeof next.images === "string") {
    try {
      const obj = JSON.parse(next.images);
      if (obj && typeof obj === "object") {
        if (obj.img) obj.img = absAssetUrl(obj.img);
        if (obj.packImg) obj.packImg = absAssetUrl(obj.packImg);
        next.images = obj;
      }
    } catch (e) {
      /* keep raw */
    }
  }
  if (next.realpicture != null && typeof next.realpicture === "string") {
    try {
      const obj = JSON.parse(next.realpicture);
      if (obj && typeof obj === "object") {
        Object.keys(obj).forEach((k) => {
          if (typeof obj[k] === "string") obj[k] = absAssetUrl(obj[k]);
        });
        next.realpicture = obj;
      }
    } catch (e) {
      /* keep raw */
    }
  }
  return next;
}

export default {
  name: "JbReportPreview",
  components: {
    JbReportNormal,
    JbReportSecondhand,
  },
  props: {
    orderId: {
      type: [Number, String],
      required: true,
    },
    orderType: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      orderData: null,
      viewMode: "",
      legacyImageUrl: "",
    };
  },
  watch: {
    orderId: {
      immediate: true,
      handler() {
        this.loadReport();
      },
    },
    orderType() {
      this.loadReport();
    },
  },
  methods: {
    loadReport() {
      const id = this.orderId;
      if (id == null || id === "") {
        this.orderData = null;
        this.viewMode = "";
        this.legacyImageUrl = "";
        return;
      }
      this.loading = true;
      this.orderData = null;
      this.viewMode = "";
      this.legacyImageUrl = "";
      const secondhand = isSecondhandJobOrderType(this.orderType);
      const url = secondhand ? api.getSecondhandOrderReport : api.getOrderReport;
      this.$axios
        .get(`${url}?id=${encodeURIComponent(id)}`)
        .then((res) => {
          if (!res.data || res.data.code !== 200) {
            this.$message.error((res.data && res.data.msg) || "获取报告失败");
            return;
          }
          const raw = res.data.data;
          const data = normalizeOrderAssets(raw);
          this.orderData = data;
          if (secondhand) {
            this.viewMode = "secondhand";
            return;
          }
          const authUrl = (data.authenticate || "").trim();
          if (useNewXwOrderReportTemplate(data)) {
            this.viewMode = "normal";
          } else if (isReportImageUrl(authUrl)) {
            this.viewMode = "legacy";
            this.legacyImageUrl = absAssetUrl(authUrl);
          } else {
            this.viewMode = "";
            this.$message.warning("该订单暂无新版报告模板数据");
          }
        })
        .catch(() => {
          this.$message.error("获取报告失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.jb-report-preview {
  min-height: 520px;
  background: #2c2c2c;
}

.jb-report-preview-legacy {
  padding: 16px;
  text-align: center;
  background: #000;
}

.jb-report-preview-legacy-img {
  max-width: 100%;
  height: auto;
}

.jb-report-preview-empty {
  padding: 48px 16px;
  text-align: center;
  color: #999;
  background: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/jbReport/JbReportPreview.vue